import './PhoneContactBlock.css';

const PhoneContactBlock = ({ className = '' }) => (
    <div className={`phone-contact-block${className ? ` ${className}` : ''}`}>
        <p className="phone-contact-block__numbers">
            <span>電話番号：03-6873-5115</span>
            <span className="phone-contact-block__numbers-second">　　　　　090-2413-6065</span>
        </p>
        <p className="phone-contact-block__note">
            施術中は電話に出られない場合がございます。<a href="https://lin.ee/qXeHGgH">公式LINE</a>よりお問い合わせいただくか、留守番電話にお名前とご用件をお残しください。折り返しご連絡いたします。
        </p>
    </div>
);

export default PhoneContactBlock;

